const dealCallback = {
  methods: {
    handleCurrentChange(currentPage) { // 处理换页回调
      let list = this.listConfig
      list.loading = true
      list.currentPage = currentPage
      this.beforeGetListData(list)
    },
    handleSizeChange(size) { // 处理单页条数切换回调
      let list = this.listConfig
      list.loading = true
      list.currentPage = 1
      list.currentSize = size
      this.beforeGetListData(list)
    },
    selectChange(value) {  // 列表行数选择回调函数
      let list = this.listConfig
      list.multipleSelection = []
      _(value).forEach((res) => {
        list.multipleSelection.push(res.id)
      })
    },
    editCallback(isSuccess, res) {  // 编辑数据回调函数
      if (isSuccess) {
        let list = this.editSource.list
        this.beforeGetListData(list)
        this.getFilterCount(list, res.data)
      }
    },
    deleteCallback(isSuccess, res) { // 删除数据回调函数
      if (isSuccess) {
        _g.toastMsg(this, 'success', '删除成功！')
        setTimeout(() => {
          _g.reloadPage(this)
        }, 1000)
      }
    },
    statusCallback(isSuccess, res) { // 改变数据状态回调函数
      if (isSuccess) {
        _g.toastMsg(this, 'success', '操作成功！')
        let list = this.statusSource.list
        if (this.statusSource.isMul) {  // 若是批量修改，置空ids数组
          list.multipleSelection = []
        }
        this.beforeGetListData(list)
        this.getFilterCount(list, res.data)
      }
    },
    importCallback(isSuccess, res) { // 导入数据回调函数
      if (isSuccess) {
        if (res.data.isConfirm) {
          this.openRepeatDialog(res.data)
        } else {
          let tips = `导入数据成功${res.data.success}条，失败${res.data.fail}条`
          _g.toastMsg(this, 'success', tips)
          setTimeout(() => {
            _g.reloadPage(this)
          }, 1000)
        }
      }
    },
    emailCallback(isSuccess) {  // 发送邮件回调
      if (isSuccess) {
        _g.toastMsg(this, 'success', '发送成功！')
      }
    }
  }
}

export default dealCallback



// WEBPACK FOOTER //
// ./src/components/Content/instance/mixins/dealCallback.js